import "./normalize.css";
import "./fonts.css";
import "./form.scss";
import "selectivity/styles/selectivity-react.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.scss";

import React from "react";
import { observer, Provider } from "mobx-react";
import { constants } from "router5";
import { RouteProvider, RouteNode } from "react-router5";
import { instanceOf } from "prop-types";
import { withCookies, Cookies, useCookies, removeCookie } from "react-cookie";
import {
  ROUTE_LOGIN,
  ROUTE_MAP,
  ROUTE_STATS,
  ROUTE_TABLE,
  ROUTE_TABLESUM,
  ROUTE_DATABASE,
  ROUTE_EVENTLOG,
  ROUTE_SEALNUMS,
  ROUTE_WORKSHIFT,
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_QUALITIES_DETAILS,
  ROUTE_RAW_QUALITIES,
  ROUTE_WEIGHBILL,
  ROUTE_MIXES,
  ROUTE_MIX,
  ROUTE_STAT_ACTIVITY,
  ROUTE_PALLET_CHECK,
  ROUTE_PALLET_CHECK_DETAILS,
  ROUTE_TRANSPORTER_MOVE,
  ROUTE_TRANSPORTER_CHECK,
  ROUTE_TRANSPORTER_CHECK_DETAILS,
} from "../../routes";
import { STORE_AUTH } from "../../Store/AuthStore";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import Map from "../Map/Map";
import Stats from "../Stats/Stats";
import Table from "../Table/Table";
import TableSum from "../TableSum/TableSum";
import NotFound from "../../Components/NotFound/NotFound";
import Login from "../Login/Login";
import Database from "../Database/Database";
import Eventlogs from "../Eventlogs/Eventlogs";
import Sealnums from "../Sealnums/Sealnums";
import Workshift from "../Workshift/Workshift";
import ProcessedQualities from "../Qualities/ProcessedQualities";
import QualitiesDetails from "../Qualities/QualitiesDetails";
import RawQualities from "../Qualities/RawQualities";
import WeighBill from "../Qualities/WeighBill";
import Mixes from "../Mix/Mixes";
import Mix from "../Mix/Mix";
import StatActivity from "../StatActivity/StatActivity";
import Popup from "../../Components/Popup/Popup";
import Button from "../../Components/Button/Button";
import PalletCheck from "../PalletCheck/PalletCheck";
import PalletCheckDetails from "../PalletCheck/PalletCheckDetails";
import TransporterMove from "../TransporterMove/TransporterMove";
import TransporterCheck from "../TransporterCheck/TransporterCheck";
import TransporterCheckDetails from "../TransporterCheck/TransporterCheckDetails";

@observer
class App extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      popup: false,
    };

    const { appStore, cookies, socket, router } = props;
    if (cookies && cookies.get("logicort-user")) {
      const store = appStore.get(STORE_AUTH);
      store.setUser(cookies.get("logicort-user"));

      if (store.token) {
        socket.emitWithToken("GetBaseData", {}, (err, data) => {
          if (err) {
            console.error(err);
            return;
          }
          appStore.get(STORE_CONFIG).setData(data);
          router.navigate(ROUTE_TABLE);
        });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleLeavePage);
  }
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleLeavePage);
  }
  handleLeavePage(e) {
    const { cookies } = props;
    removeCookie("logicort-user");
    //cookies.set('logicort-user', null)
  }
  componentWillReceiveProps(newprop) {
    if (newprop.networkpopup) {
      this.setState({ popup: true });
    }
  }

  render() {
    const { appStore, router, socket } = this.props;
    const { popup } = this.state;

    return (
      <Provider store={appStore} socket={socket} router={router}>
        <RouteProvider router={router}>
          <RouteNode nodeName="">
            {({ route, previousRoute, router }) => {
              const { name } = route;
              return name === constants.UNKNOWN_ROUTE ? (
                <NotFound />
              ) : name === ROUTE_MAP ? (
                <Map />
              ) : name === ROUTE_STATS ? (
                <Stats />
              ) : name === ROUTE_TABLE ? (
                <Table />
              ) : name === ROUTE_TABLESUM ? (
                <TableSum />
              ) : name === ROUTE_LOGIN ? (
                <Login />
              ) : name === ROUTE_DATABASE ? (
                <Database />
              ) : name === ROUTE_EVENTLOG ? (
                <Eventlogs />
              ) : name === ROUTE_SEALNUMS ? (
                <Sealnums />
              ) : name === ROUTE_WORKSHIFT ? (
                <Workshift />
              ) : name === ROUTE_PROCESSED_QUALITIES ? (
                <ProcessedQualities />
              ) : name === ROUTE_QUALITIES_DETAILS ? (
                <QualitiesDetails />
              ) : name === ROUTE_RAW_QUALITIES ? (
                <RawQualities />
              ) : name === ROUTE_WEIGHBILL ? (
                <WeighBill />
              ) : name === ROUTE_MIXES ? (
                <Mixes />
              ) : name === ROUTE_MIX ? (
                <Mix />
              ) : name === ROUTE_STAT_ACTIVITY ? (
                <StatActivity />
              ) : name === ROUTE_PALLET_CHECK ? (
                <PalletCheck />
              ) : name === ROUTE_PALLET_CHECK_DETAILS ? (
                <PalletCheckDetails />
              ) : name === ROUTE_TRANSPORTER_MOVE ? (
                <TransporterMove />
              ) : name === ROUTE_TRANSPORTER_CHECK ? (
                <TransporterCheck />
              ) : name === ROUTE_TRANSPORTER_CHECK_DETAILS ? (
                <TransporterCheckDetails />
              ) : null;
            }}
          </RouteNode>
          {popup && (
            <Popup
              key="popup"
              text="Hálózati hiba történt, ellenőrizze a művelet eredményét."
              buttons={[
                <Button
                  onClick={(e) => {
                    this.setState({ popup: false });
                  }}
                >
                  Ok
                </Button>,
              ]}
              onClickClose={() => this.setState({ popup: false })}
            />
          )}
        </RouteProvider>
      </Provider>
    );
  }
}
export default withCookies(App);
